export default __webpack_public_path__ + "static/media/cp_geo_gh.2bbc2039.svg";